export default class NodePopover {
  constructor({ nodePopoverText = null } = {}) {
    if (this._isFunction(nodePopoverText)) {
      this._nodePopoverText = nodePopoverText;
    } else {
      this._nodePopoverText = () => nodePopoverText;
    }
  }

  get key() {
    return 'nodePopover';
  }

  _isFunction = item => typeof item === 'function';

  getNodePopoverText(treeState, nodeId) {
    if (!this._nodePopoverText && !treeState.models[nodeId]) {
      return null;
    }
    return this._nodePopoverText(treeState.models[nodeId]);
  }
}
